<template>
  <button :disabled="disabled" class="v-btn" @click.stop="btn_click" ref="vBtn">
    <slot />
  </button>
</template>

<script>
export default {
  name: "v-btns",
  data() {
    return {};
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    btn_click() {
      this.$emit("btnClick");
    },
  },
};
</script>

<style lang="scss"></style>
